import(/* webpackMode: "eager" */ "/home/runner/work/frontweb/frontweb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/frontweb/frontweb/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/frontweb/frontweb/src/components/_rebrand/Header.tsx");
